import React from "react";
import { HeaderSearchPanelView } from "./view";
import { styles } from "./styles";

export class HeaderSearchPanel extends React.Component {
  render() {
    return <HeaderSearchPanelView {...this.props} styles={styles} />;
  }
}
